module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/I8dWQr/tc-custom/cover.jpg?1685327425226?1714620142877",
      "alt": "This image is the cover for the book My Aim Is True"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("My Aim Is True\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When sixteen-year-old Guy Dimchek comes out in 1970s San Francisco, his best friend dumps him, his mom splits, and he’s left largely on his own just in time for his first ever sexual experience.")]), _c('p', [_vm._v("Things don’t get any easier when Guy’s father becomes a candidate for state office. Having a gay son doesn’t do his candidacy any favors, especially under the antigay “family values” fervor sweeping the nation. Compounding the situation is Guy’s new stepmother, who opposes openness on the gay issue and especially the revelation that Guy has a boyfriend—one he might be falling in love with.")]), _c('p', [_vm._v("Around Guy, self-help charlatans, radical cults, and extreme politics forecast 1978’s perfect tsunami: the Jonestown massacre in Guyana, Anita Bryant’s homophobic campaign, and gay city supervisor Harvey Milk’s assassination at city hall. In the midst of a perfect storm of antigay sentiment, Guy faces the supreme test when his father’s political opponent launches a smear campaign that employs both dirty tricks and physical violence against Guy.")]), _c('p', [_vm._v("Following the attack, an injured Guy must confront his own flaws and reunite with his fractured family—all while staying true to himself and connected to the boy he loves.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lee Patton\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0